// Radius in nail coordinates, independent from the drawing pen width.
export const ERASER_RADIUS = Object.freeze({min:1,max:15,step:.5,default:5});

export function normalizeEraserRadius(value){
 const radius=typeof value==='number'?value:Number(value);
 if(value===null||value===''||!Number.isFinite(radius))return ERASER_RADIUS.default;
 return Math.max(ERASER_RADIUS.min,Math.min(ERASER_RADIUS.max,Math.round(radius/ERASER_RADIUS.step)*ERASER_RADIUS.step));
}
